import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { setMerchantIsRequired } from "../../Merchants";

const Container = styled.div`
  flex: 1 1 0%;
`;

const CardBalance = ({
  merchantSelectorFocus,
  defaultValue,
  onChange,
  hasMerchant,
  maxLength,
  min,
  max,
}) => {
  const dispatch = useDispatch();

  const onFocus = () => {
    if (!hasMerchant) {
      dispatch(setMerchantIsRequired(true));
      merchantSelectorFocus();
    }
  };

  return (
    <Container>
      <input
        defaultValue={defaultValue}
        type="text"
        onChange={(e) => {
          e.persist();

          const value = e.target.value.trim();
          let error = false;
          let msg = "";

          if (!value) {
            error = true;
            msg = "Balance is required.";
          } else if (Number(value) < Number(min)) {
            error = true;
            msg = "Balance is less than accepted minimum for this brand.";
          } else if (Number(value) > Number(max)) {
            error = true;
            msg = "Balance is greater than accepted maximum for this brand.";
          }

          onChange(e.target.name, value, error, msg);
        }}
        onFocus={() => onFocus()}
        className={"form-control"}
        placeholder={"Balance"}
        size={maxLength}
        name="balance"
      />
    </Container>
  );
};

CardBalance.DefaultProps = {
  defaultValue: null,
  min: 0.0,
  max: 0.0,
};

CardBalance.propTypes = {
  merchantSelectorFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hasMerchant: PropTypes.bool.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,

  maxLength: PropTypes.number,
  defaultValue: PropTypes.string,
};

export { CardBalance };
